export class MenuItem {
  constructor(
    public description: string,
    public order: number,
    public icon: string,
    public action: () => void,
    public isVisible: () => boolean = () => { return true; }) {
  }
}
